"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_OFF = exports.SEIZED_PROPERTY = exports.LOSS = exports.INSIDER_BENEFIT = exports.INSIDER = exports.INDIVIDUAL = exports.HELD_PROPERTY = exports.FINANCIAL_STATEMENTS = exports.CREDITOR = exports.CONTRIBUTION = exports.CONSULTANT = exports.ASSET_PROTECTION_DEVICE = void 0;
var ASSET_PROTECTION_DEVICE = 'asset_protection_device';
exports.ASSET_PROTECTION_DEVICE = ASSET_PROTECTION_DEVICE;
var CONSULTANT = 'consultant';
exports.CONSULTANT = CONSULTANT;
var CONTRIBUTION = 'contribution';
exports.CONTRIBUTION = CONTRIBUTION;
var CREDITOR = 'creditor';
exports.CREDITOR = CREDITOR;
var FINANCIAL_STATEMENTS = 'financial_statements';
exports.FINANCIAL_STATEMENTS = FINANCIAL_STATEMENTS;
var HELD_PROPERTY = 'held_property';
exports.HELD_PROPERTY = HELD_PROPERTY;
var INDIVIDUAL = 'individual';
exports.INDIVIDUAL = INDIVIDUAL;
var INSIDER = 'insider';
exports.INSIDER = INSIDER;
var INSIDER_BENEFIT = 'insider_benefit';
exports.INSIDER_BENEFIT = INSIDER_BENEFIT;
var LOSS = 'loss';
exports.LOSS = LOSS;
var SEIZED_PROPERTY = 'seized_property';
exports.SEIZED_PROPERTY = SEIZED_PROPERTY;
var SET_OFF = 'set_off';
exports.SET_OFF = SET_OFF;